export default __webpack_public_path__ + "static/media/Background_00004.a60fff7b.png";